import { Grid } from '@mui/material';
import DashboardKurulMeetingsCard from '../DashboardKurulMeetingsCard';
import DashboardParticipantCard from '../DashboardParticipantCard';
import DashboardUserInfoMeetingsCard from '../DashboardUserInfoMeetingsCard';
import DashboardAnnouncementsCard from '../DashboardAnnouncementsCard';

function DashboardKurulOnlyDesign({ countList, countUserInfo, participantList }) {
    return (

        <Grid container spacing={1}>

            <Grid item xs={12} lg={9}>
                <Grid container >

                    <Grid item xs={12} style={{ marginBottom: 5 }}>

                        <DashboardKurulMeetingsCard countList={countList} />

                    </Grid>

                    <Grid item xs={12} md={8} lg={8} >

                        <DashboardParticipantCard mainData={participantList} />

                    </Grid>

                    <Grid item xs={12} md={4} lg={4}  >

                        <DashboardUserInfoMeetingsCard countList={countUserInfo} />

                    </Grid>


                </Grid>
            </Grid>

            <Grid item xs={12} lg={3}>

                <DashboardAnnouncementsCard />

            </Grid>
        </Grid>

    );
}

export default DashboardKurulOnlyDesign; 